/**
 * epgTimelineDate.tsx
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgTimelineDate = styled.div`
  text-align: left;
  color: ${Colors['text']};
  font-family: ${Fonts['bold']};
  font-size: ${24 * Screen.widthRatio}px;
  white-space: nowrap;
`;

export default EpgTimelineDate;
